import React, { useState, useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import BenchmarkSidebar from '@/components/benchmark/BenchmarkSidebar';
import BenchmarkDataTable from '@/components/benchmark/BenchmarkDataTable';
import { useBenchmarkData, useBenchmarkProducts } from '@/hooks/use-benchmark-data';
import { BenchmarkFilters } from '@/services/benchmarkDataService';

const Benchmark: React.FC = () => {
  // Initialize filters with default values (1 week range)
  const getDefaultDateRange = () => {
    const today = new Date();
    const weekAgo = new Date(today);
    weekAgo.setDate(today.getDate() - 7);
    
    return {
      dateFrom: weekAgo.toISOString().split('T')[0],
      dateTo: today.toISOString().split('T')[0],
    };
  };

  const [filters, setFilters] = useState<BenchmarkFilters>({
    ...getDefaultDateRange(),
    product: '',
    locationGroups: ['local-shops', 'sunday-market', 'supermarket', 'ecommerce', 'distribution-center', 'farm-prices', 'chipchip-sales-db'],
    frequency: 'daily',
    comparisonType: 'min',
  });

  const { data: products = [], isLoading: productsLoading } = useBenchmarkProducts();
  const { data: benchmarkData, isLoading: dataLoading } = useBenchmarkData(filters);

  // Set the first product as default when products are loaded
  useEffect(() => {
    if (products.length > 0 && !filters.product) {
      setFilters(prev => ({ ...prev, product: products[0] }));
    }
  }, [products, filters.product]);

  return (
    <Layout fullWidth>
      <div className="flex h-screen bg-white w-full">
        <BenchmarkSidebar
          filters={filters}
          onFiltersChange={setFilters}
          products={products}
        />
        <div className="flex-1 overflow-hidden w-full">
          <BenchmarkDataTable
            data={benchmarkData || { locationGroups: [], allDates: [] }}
            comparisonType={filters.comparisonType}
            frequency={filters.frequency}
            isLoading={dataLoading || productsLoading}
            productName={filters.product}
            dateFrom={filters.dateFrom}
            dateTo={filters.dateTo}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Benchmark;
